import { useState, useEffect } from 'react';
import api from '../api';

let cachedAuth = null;
let fetchPromise = null;

export function useAvatarAuth() {
  const [auth, setAuth] = useState(cachedAuth);

  useEffect(() => {
    if (cachedAuth) {
      setAuth(cachedAuth);
      return;
    }

    if (!fetchPromise) {
      fetchPromise = api.get('/content/avatar-auth')
        .then(({ data }) => {
          cachedAuth = data;
          return data;
        })
        .catch(() => null);
    }

    fetchPromise.then((data) => {
      if (data) setAuth(data);
    });
  }, []);

  return auth;
}
